import { createContext } from "react";

const FormBuilderContext = createContext();

export default FormBuilderContext;
